import React, {useState} from 'react';
import {useUserContext} from '../../../providers/user-context';
import styles from './styles.module.scss';
import {Avatar} from 'components/chakra-ui/avatar';
import {useAuth} from '../../../hooks/useAuth';
import {shortTimeout} from '../../../api/auth';
import LogoutModal from '../../../components/logout-dialog';

const Main: React.FC = () => {
  const {user} = useUserContext();
  const {setUser, userLoading, setUserLoading} = useUserContext();
  const {logout: handleLogout} = useAuth();
  const [isOpen, setOpen] = useState(false);

  const toggleModal = () => {
    setOpen(!isOpen);
  };

  // Function with logic handle logout (remove token, user, and redirect to home)
  const onLogout = async () => {
    // Simulate a short delay for logout lodainng animation
    setUserLoading(true);
    await shortTimeout();
    setUserLoading(false);
    handleLogout();  // Now actually call the logout function, remove user, token and redirect to home
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.avatar}>
        <Avatar name={user?.username} size="full" />
      </div>
      <div className={styles.info}>
        <h1 className={styles.userCred}>{user?.email}</h1>
        <LogoutModal
          isOpen={isOpen}
          onOpenChange={toggleModal}
          onLogout={onLogout}
          isLoading={userLoading}
          triggerElement={<div className={styles.logout}>Log out</div>}
        />
      </div>
    </div>
  );
};

export default Main;
